import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  name: 'CoreAccountSelector',
  inheritAttrs: false,
  props: {
    value: {
      type: [Object, Number],
      default: function _default() {
        return null;
      },
      required: false
    }
  },
  data: function data() {
    return {
      accounts: [],
      isLoading: false,
      commonAttrs: {},
      disabled: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['color', 'inpOutlined', 'inpFilled'])), {}, {
    isRequired: function isRequired() {
      return this.$attrs.required === '' || Boolean(this.$attrs.required);
    },
    isDisabled: function isDisabled() {
      return this.isLoading || this.$attrs.disabled || this.disabled;
    }
  }),
  mounted: function mounted() {
    this.fetchAccounts();
  },
  methods: {
    /**
     * Fetch accounts from the API and store them in the accounts array.
     * @returns {void}
     */
    fetchAccounts: function fetchAccounts() {
      var _this = this;

      this.isLoading = true;
      this.$store.dispatch('app/loadAccounts').then(function (accounts) {
        _this.accounts = accounts;

        _this.$emit('accounts-loaded');
      }).catch(function (error) {
        _this.disabled = true;

        _this.$snack(_this.$i18n_t('Common.errorLoadingAccounts'), 'error');

        _this.$emit('accounts-error');

        console.error(error);
      }).finally(function () {
        _this.isLoading = false;
      });
    }
  }
};